import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import {
  completePartnerOnboarding
  
} from "../../../../api/partner/onboarding";
const SuccessStep = ({ onGoToDashboard }) => {

// const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

  const handleGoToProfile = async () => {
    try {
      // setLoading(true);
      // setError("");

      // 🔹 Call backend onboarding completion API
      await completePartnerOnboarding();

      // 🔹 Navigate to partner profile/dashboard
      if (onGoToDashboard) onGoToDashboard();
    } catch (err) {
      console.error("Onboarding completion failed", err);
     // setError("Something went wrong. Please try again.");
    } finally {
     // setLoading(false);
    }
  };







  return (
    <div className="onboarding-success-screen">
      <div className="onboarding-success-icon">
        <FaCheckCircle size={60} color="#4BB543" />
      </div>
      <h2>Onboarding Complete!</h2>
      <p>Your profile has been successfully created and your R2R Kit will be shipped soon.</p>
      <p>Welcome to the Ready2Rental partner community!</p>

      <button 
        className="btn btn-primary" 
         onClick={handleGoToProfile}
        // onClick={() => {
        //   if (onGoToDashboard) onGoToDashboard();
        // }}
      >
        Go to Profile
      </button>
    </div>
  );
};

export default SuccessStep;
